export default "__VITE_ASSET__CMtYhKG7__"